
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9316_6784)","fill":"#00AEEF"}},[_c('path',{attrs:{"d":"M32 18.667a5.99 5.99 0 00-4-5.652V12a12 12 0 00-24 0v1.015a6 6 0 000 11.31 2 2 0 002.667-1.885V12a9.333 9.333 0 1118.666 0v10.44A1.992 1.992 0 0026 23.907v.76c0 1.965-1.721 2.666-3.333 2.666h-2.37a2.667 2.667 0 100 2.667h2.37c3.533 0 6-2.193 6-5.333v-.638A6 6 0 0032 18.667z"}}),_c('path',{attrs:{"d":"M20.192 18.727a1.112 1.112 0 011.863 1.216 7.225 7.225 0 01-12.107 0 1.114 1.114 0 111.867-1.216 5 5 0 008.384 0h-.007zM11.556 14.89a2.223 2.223 0 100-4.445 2.223 2.223 0 000 4.446zM20.444 14.89a2.223 2.223 0 100-4.445 2.223 2.223 0 000 4.446z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9316_6784"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    